import React from 'react';
import DetailCard from './DetailCard';
import styles from './DetailCard.css';
import ListItem from '../ListItem';

function DetailRequirements() {
  return (
    <div className={styles['detail-requirements']}>
      <DetailCard title="Persyaratan Pengajuan Term Loan" border="yellow">
        <ListItem>Merchant Moka minimal 3 bulan</ListItem>
        <ListItem>Penjualan per bulan minimal Rp5 juta</ListItem>
        <ListItem>Merupakan pemilik dari bisnis yang diajukan</ListItem>
        <ListItem>
          Akun yang digunakan harus akun pemilik bisnis atau administrator
        </ListItem>
      </DetailCard>
    </div>
  );
}

export default DetailRequirements;
